import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";
import { LikeEmailFrequency } from "../../data/likeEmailPreferenceApi";

const options: Array<{ value: LikeEmailFrequency; label: string; detail: string }> = [
	{
		value: "daily",
		label: "Daily",
		detail: "One bundled reminder at most once every 24 hours when there are genuine new likes.",
	},
	{
		value: "weekly",
		label: "Weekly",
		detail: "One bundled reminder each week when there are genuine new likes.",
	},
	{
		value: "never",
		label: "Never",
		detail: "Do not send Likes You reminder emails.",
	},
];

export const LikeEmailFrequencySelector = ({
	value,
	disabled = false,
	onChange,
}: {
	value: LikeEmailFrequency;
	disabled?: boolean;
	onChange: (value: LikeEmailFrequency) => void;
}) => (
	<Column className="gap-3" role="radiogroup" aria-label="Likes You email frequency">
		{options.map((option) => (
			<label
				key={option.value}
				className={`flex gap-3 rounded-lg border p-4 ${
					value === option.value ? "border-primary bg-[#FCE7F7E5]" : "border-grayLight"
				} ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"}`}
			>
				<input
					type="radio"
					name="like-email-frequency"
					value={option.value}
					checked={value === option.value}
					disabled={disabled}
					onChange={() => onChange(option.value)}
					className="mt-1 accent-primary"
				/>
				<Column className="gap-1">
					<TextComponent variant="h5" className="font-semibold">
						{option.label}
					</TextComponent>
					<TextComponent variant="h6" className="text-graySecondary">
						{option.detail}
					</TextComponent>
				</Column>
			</label>
		))}
	</Column>
);
